import module from '@app/module'

module.run(($state, $transitions, $window, $log, $rootScope, $localStorage, AppHttpCache) => {
  $rootScope.$watch(() => $localStorage.token,
    (token, previousToken) => {
      if (token === previousToken) return

      AppHttpCache.destroy()

      if (token) $rootScope.$broadcast('$sessionAuth')
      else $rootScope.$broadcast('$sessionUnauth')
    })

  /*
   $window.addEventListener('storage', (e) => {
   console.log(e)

   if (e.key === 'ngStorage-token') {
   if (e.newValue === e.oldValue) return

   $rootScope.$applyAsync(() => {
   AppHttpCache.destroy()

   if (e.newValue) $rootScope.$broadcast('$sessionAuth')
   else $rootScope.$broadcast('$sessionUnauth')
   })
   }
   })
   */

  const localhost = $window.location.hostname === 'localhost'
  const navigator = $window.navigator
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)

  if (localhost || isSafari || isChrome) return

  $log.warn('Browser not supported. Navigator: %s | Vendor: %s', navigator.userAgent, navigator.vendor)

  const redirectTo = 'nosoportado'
  const criteria = {to: (state) => state.name !== redirectTo}

  $transitions.onBefore(criteria, (trans) => trans.router.stateService.target(redirectTo))
})



// WEBPACK FOOTER //
// ./src/app/run.js